import ManageUsersController from './controller/ManageUsersController.js'
import template from './manageUsers.component.tpl.pug'

const manageUsers = {
  template: template(),
  controller: ManageUsersController,
}

export default manageUsers
